<template>
  <!-- 七天试用期内弹框 -->
  <a-modal
    v-model="visible"
    title=""
    :centered="true"
    :footer="null"
    :maskClosable="false"
    dialogClass="global-campaign-modal-class"
    :closable="false"
  >
    <div class="modal-con" :class="[lang]">
      <a-icon type="exclamation-circle" theme="filled" class="warin-icon" />
      <div class="tip-txt" v-html="tipTxt"></div>
      <a-button type="primary" class="btn" @click="saveLinkedIn">{{
        $t("CampaignModalTipBtn")
      }}</a-button>
    </div>
  </a-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    newLinkedIn: {
      type: Array,
      default: () => [],
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  i18n: require("./i18n"),
  computed: {
    ...mapState("setting", ["lang"]),
    tipTxt() {
      return this.$t("CampaignModalTipTxt").replace(
        "AAA",
        '<a href="mailto:' +
          this.newLinkedIn.join("、") +
          '">' +
          this.newLinkedIn.join("、") +
          "</a>"
      );
    },
    visible: {
      get() {
        return this.showModal;
      },
      set(val) {
        this.$emit("update:showModal", val);
      },
    },
  },
  methods: {
    saveLinkedIn() {
      this.$emit("saveLinkedIn");
    },
  },
};
</script>

<style lang="less" scoped>
.modal-con {
  padding: 40px 0;
  text-align: center;
  .warin-icon {
    font-size: 48px;
    color: #ff9a41;
  }
  .tip-txt {
    font-size: 16px;
    color: #000000;
    font-weight: 400;
    line-height: 24px;
    padding: 24px;
  }
  .btn {
    padding: 0 50px;
    height: 48px;
    line-height: 46px;
  }
}
</style>
<style lang="less">
.global-campaign-modal-class {
  width: 620px !important;
  .ant-modal-body {
    padding: 0;
    position: relative;
  }
  .ant-modal-close {
    right: -4px;
    top: -2px;
  }
}
</style>
